import React from 'react';
import { IconButton, InputAdornment, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import InputUI from './InputUI';

const PhoneInputUI = (props) => {
  const { value } = props;
  return (
    <InputUI
      {...props}
      InputProps={{
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton component={Link} href={`tel:${value}`}>
              <PhoneIcon />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default PhoneInputUI;
